import React from 'react'
import { VictoryPie } from 'victory'

export const PieChart = (
    {
        data,
        radius,
        isRounded,
        strokeWidth,
        centerElement,
        testID,
    }: {
        strokeWidth: number,
        radius: number;
        isRounded?: boolean,
        testID?: string;
        centerElement?: React.ReactNode;
        data: {
            x: string | number,
            y: number,
            color: string
        }[]
    }) => {
    return (
        <div data-testid={testID} style={{ position: 'relative' }}>
            <div>
                <VictoryPie
                    data={data}
                    colorScale={data?.map(d => d.color)}
                    labels={({ datum }) => ''}
                    radius={radius}
                    innerRadius={radius - strokeWidth}
                    padAngle={2}
                    cornerRadius={isRounded ? strokeWidth : 0}
                />
                <div style={{ position: 'absolute', width: '100%', top: '0', alignItems: 'center' }}>
                    {centerElement}
                </div>
            </div>
        </div>
    )
}

PieChart.defaultProps = {
    data: [],
    radius: 200,
    strokeWidth: 10,
    isRounded: false
}